/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：76
 */

"use strict"

var r
var o
var i
export { r as c }
export { o as a }
export { i as b };
(function (e) {
  e.CONTAINED_NORMAL = "CONTAINED_NORMAL"
  e.CONTAINED_ROUND = "CONTAINED_ROUND"
  e.OUTLINED_NORMAL = "OUTLINED_NORMAL"
  e.OUTLINED_FLAT = "OUTLINED_FLAT"
})(r || (r = {}));
(function (e) {
  e.TEMPLATE = "TEMPLATE"
  e.IMAGE = "IMAGE"
})(o || (o = {}));
(function (e) {
  e.CONTAIN = "contain"
  e.STRETCH = "stretch"
})(i || (i = {}))
export default o
